import Edit from "./Edit";
import List from "./List";
import Show from "./Show";

export const UserEdit = Edit;
export const UserList = List;
export const UserShow = Show;
